import { render, staticRenderFns } from "./EstudiosForm.vue?vue&type=template&id=4bdbb0cf&scoped=true&"
import script from "./EstudiosForm.vue?vue&type=script&lang=js&"
export * from "./EstudiosForm.vue?vue&type=script&lang=js&"
import style0 from "./EstudiosForm.vue?vue&type=style&index=0&id=4bdbb0cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdbb0cf",
  null
  
)

export default component.exports